import { buildFrequencyRequestBody } from "@/api/frequencyPolicy";
import { getAppStore } from "../app/app.bridge";
import { getFleetStore } from "../fleet/fleet.getters.bridge";
/** Frekans analiz fetch — Pinia birincil kaynak (micro-5-16, micro-8-2) */
export const frequencyAnalysisActions = {
    async fetchAnalysisData(params) {
        const app = getAppStore();
        const fleet = getFleetStore();
        try {
            const hatNo = String(params?.hatNo ?? "").trim();
            if (!hatNo) {
                const err = new Error("Hat numarası gerekli. Lütfen hat no girin (örn: 800, 5A).");
                app.setError(err.message);
                throw err;
            }
            app.setLoading(true);
            app.setError(null);
            localStorage.removeItem("currentParkurSureleri");
            localStorage.removeItem("originalParkurSureleri");
            localStorage.removeItem("vehicleAssignments");
            localStorage.removeItem("planStoreData");
            fleet.clearVehicleData();
            this.resetPlansAndTypes();
            fleet.resetVehicleTypes();
            const built = buildFrequencyRequestBody(params, params?.vehicleCatalog);
            if (!built.ok || !built.body) {
                const err = new Error(built.message || "Frekans isteği gönderilmedi");
                app.setError(err.message);
                throw err;
            }
            const wire = {
                ...built.body,
                hatNo: String(built.body.hatNo ?? params?.hatNo ?? ""),
            };
            const { default: api } = await import("@/services/api");
            const result = await api.analyze(wire);
            app.setAnalysisData(result.data);
            const base = result.optimization && typeof result.optimization === "object"
                ? { ...result.optimization }
                : {};
            const optimization = result.typeOutcome
                ? { ...base, typeOutcome: result.typeOutcome }
                : result.optimization;
            app.setOptimizationData(optimization);
            app.setCurrentMethod(1);
            if (result.data && result.data.gidis && result.data.donus) {
                fleet.setParkurSureleri({
                    gidis: result.data.gidis.parkur_suresi || {},
                    donus: result.data.donus.parkur_suresi || {},
                });
            }
            return result;
        }
        catch (error) {
            app.setError(error.message);
            throw error;
        }
        finally {
            app.setLoading(false);
        }
    },
};
